import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Typography from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import Button from '@jobcase/react_pattern_library/components/Button';
import Link from '@jobcase/react_pattern_library/components/Link/LinkRebrand';
import Spinner from '@jobcase/react_pattern_library/components/Spinner';
import rebrandStyles from '@jobcase/react_pattern_library/styles/rebrand';

import MobileModal from '../MobileModal';

const MobileModalStyle = styled(MobileModal)`
  && {
    margin: 0 auto;
    padding: ${rebrandStyles.spacing.medium}px ${rebrandStyles.spacing.tiny}px ${rebrandStyles.spacing.tiny + 4}px;
    top: 50%;
    transform: translateY(-50%);
    max-width: 382px;

    @media (min-width: ${rebrandStyles.breakpoint.md}) {
      padding: ${rebrandStyles.spacing.medium}px ${rebrandStyles.spacing.small}px;
      max-width: 398px;
    }
  }

  [class*="Modal__CloseIcon"] {
    right: ${rebrandStyles.spacing.tiny}px;
    top: ${rebrandStyles.spacing.tiny}px;

    @media (min-width: ${rebrandStyles.breakpoint.md}) {
      right: ${rebrandStyles.spacing.small}px;
      top: ${rebrandStyles.spacing.small}px;
    }

    svg {
      height: 24px;
      width: 24px;
      
      path {
        fill: ${rebrandStyles.color.jobcaseBlackColor};
      }
    }  
  }
`;

const StyledHeading = styled(Typography)`
  font-size: ${rebrandStyles.font.fontSize.h1Mobile};
  line-height: ${rebrandStyles.font.lineHeight.h1Mobile};
  margin: ${rebrandStyles.spacing.tiny}px 0;
  max-width: 290px;
  word-break: break-word;

  @media (min-width: ${rebrandStyles.breakpoint.md}) {
    font-size: ${rebrandStyles.font.fontSize.h1};
    line-height: ${rebrandStyles.font.lineHeight.h1};
    margin-top: ${rebrandStyles.spacing.medium}px;
  }
`;

const StyledText = styled(Typography)`
  color: ${rebrandStyles.color.bodyTextColor};
  line-height: ${rebrandStyles.font.lineHeight.body2};
  margin-bottom: ${rebrandStyles.spacing.medium}px;
  max-width: 350px;

  @media (min-width: ${rebrandStyles.breakpoint.md}) {
    max-width: 334px;
  }
`;

const PrimaryButtonWrapper = styled.div`
  text-align: center;
`;

const PrimaryButton = styled(Button)`
  padding: 0;
  vertical-align: top;
  width: 100%;
`;

const SecondaryButtonWrapper = styled.span`
  display: block;
  margin-top: ${rebrandStyles.spacing.small + 4}px;
  text-align: center;
`;

const SecondaryButton = styled(Link)`
  font-family: ${rebrandStyles.font.fontFamilyTitle};
  font-size: ${rebrandStyles.font.fontSize.h3};
  font-weight: 500;
  padding: 0;
`;

const PromptEventModalRebrand = ({
  className,
  children,
  onClose,
  isVisible,
  isLoading,
  primaryOnClick,
  primaryButtonText,
  secondaryOnClick,
  showSecondaryButton,
  secondaryButtonText,
  headerText,
  bodyText,
  closeOnMaskClick,
  color,
  hasCloseButton,
}) => (
  <MobileModalStyle
    className={className}
    onClose={onClose}
    isMobile={false}
    isVisible={isVisible}
    hasCloseButton={hasCloseButton}
    closeOnMaskClick={closeOnMaskClick}
  >
    <StyledHeading className={className ? `${className}-heading` : ''} variant="h1" color={color}>{headerText}</StyledHeading>
    {
      bodyText && (<StyledText className={className ? `${className}-body` : ''} variant="body">{bodyText}</StyledText>)
    }
    {children}
    <PrimaryButtonWrapper>
      <PrimaryButton onClick={primaryOnClick} isDisabled={isLoading}>
        {isLoading ? <Spinner color={rebrandStyles.color.jobcaseWhiteColor} /> : primaryButtonText}
      </PrimaryButton>
    </PrimaryButtonWrapper>
    {showSecondaryButton && (
    <SecondaryButtonWrapper>
      <SecondaryButton
        onClick={secondaryOnClick}
      >
        {secondaryButtonText}
      </SecondaryButton>
    </SecondaryButtonWrapper>
    )}
  </MobileModalStyle>
);

PromptEventModalRebrand.propTypes = {
  closeOnMaskClick: PropTypes.bool,
  showSecondaryButton: PropTypes.bool,
  isVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
  secondaryButtonText: PropTypes.string,
  headerText: PropTypes.string,
  bodyText: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  primaryButtonText: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  primaryOnClick: PropTypes.func,
  secondaryOnClick: PropTypes.func,
  hasCloseButton: PropTypes.bool,
};

PromptEventModalRebrand.defaultProps = {
  closeOnMaskClick: true,
  showSecondaryButton: false,
  isVisible: false,
  isLoading: false,
  secondaryButtonText: '',
  headerText: '',
  bodyText: '',
  color: '',
  className: '',
  primaryButtonText: '',
  children: null,
  onClose: null,
  primaryOnClick: null,
  secondaryOnClick: null,
  hasCloseButton: true,
};

export default PromptEventModalRebrand;
